var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9571 22.7145C17.8981 22.7145 22.7142 17.8983 22.7142 11.9573C22.7142 6.01633 17.8981 1.2002 11.9571 1.2002C6.01609 1.2002 1.19995 6.01633 1.19995 11.9573C1.19995 17.8983 6.01609 22.7145 11.9571 22.7145Z",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9571 21.9975C14.1175 21.9975 15.8688 17.5024 15.8688 11.9575C15.8688 6.41254 14.1175 1.91748 11.9571 1.91748C9.79673 1.91748 8.04541 6.41254 8.04541 11.9575C8.04541 17.5024 9.79673 21.9975 11.9571 21.9975Z",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.15576 17.7061C5.47124 16.6374 8.54371 16.103 12.3732 16.103C16.2026 16.103 19.2751 16.6374 21.5905 17.7061",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.15576 7.06787C5.47124 8.13656 8.54371 8.6709 12.3732 8.6709C16.2026 8.6709 19.2751 8.13656 21.5905 7.06787",
    stroke: "#202020",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.e4cf6e4a955956cc3642e4c405cd551b.svg";
export { ForwardRef as ReactComponent };